<template>
  <div class="lesson-list">
    <ucar-title>我的课程</ucar-title>
    <div class="lesson-list-header">
      <div class="lesson-type" @click="learnProcess = 0" :class="{'active': learnProcess === 0}">待学习</div>
      <div class="lesson-type" @click="learnProcess = 1" :class="{'active': learnProcess === 1}">已学习</div>
    </div>
    <div class="lesson-list-body">
      <div class="train-empty" v-show="learnProcess === 0 && loadComplete && list.length === 0">
        <img src="../../assets/icon-trainComplete.png">
        <p>恭喜您，岗前培训已全部完成</p>
        <p>报名审核通过后即可开始工作!</p>
      </div>
      <div class="train-empty" v-show="learnProcess === 1 && loadComplete && list.length === 0">
        <img src="../../assets/icon-trainNoStart.png">
        <p>您暂无已完成课程，快去学习吧。</p>
      </div>
      <scroller v-show="loadComplete && list.length > 0" :on-refresh="refresh" :on-infinite="loadMore">
        <lesson-item :key="item.id" v-for="item in list"
          :id="item.id"
          :icon-url="item.iconUrl"
          :title="item.title"
          :releaseTime="item.releaseTime"
          :credit="item.credit"
          :learnedCount="item.learnedCount"
          :first-class-name="item.firstClassName"
          :second-class-name="item.secondClassName"
          :required="item.required"
          ></lesson-item>
      </scroller>
    </div>
  </div>
</template>

<script>
import LessonItem from '../../components/lesson-item'
import { getLessonList } from '../../api'
export default {
  components: {
    LessonItem
  },
  data () {
    return {
      title: '我的课程',
      pageNo: 1,
      learnProcess: 0,
      loadComplete: false,
      list: []
    }
  },
  watch: {
    learnProcess () {
      this.refresh()
    }
  },
  methods: {
    async getData (append, done) {
      if (!append) {
        this.pageNo = 1
      }
      this.loadComplete = false
      try {
        const res = await getLessonList({
          relevanceId: Number(this.vuexRecruitId),
          pageNo: this.pageNo,
          pageSize: 10,
          learnProcess: this.learnProcess,
          requiredStatus: -1
        })
        this.loadComplete = true
        this.list = append ? this.list.concat(res.courseList) : res.courseList
        this.noInfo = !res.courseList.length && this.pageNo === 1
        // 判断是否传入done方法，用于结束上下拉刷新，如果已经显示到最后一条，则done(true)
        if (done) {
          if (res.courseList.length < 10) {
            done(true)
          } else {
            done()
          }
        }
        // 获取完成数据，页码+1
        this.pageNo++
      } catch (error) {
        this.loadComplete = true
        done(true)
      }
    },
    refresh (done) {
      this.getData(null, done)
    },
    loadMore (done) {
      this.getData(true, done)
    }
  },
  mounted () {
    this.refresh()
  }
}
</script>

<style lang="stylus" scoped>
@import '../../styles/variable.styl';

.lesson-list {

  .lesson-list-header {
    background-color: #fff;
    height: 80px;
    display: flex;
    align-items: center;

    .lesson-type {
      padding: 0 30px;
      border-left: 1PX solid $ucar_font_assist_color;
      line-height: 1;
      font-size: $ucar_font_normal;

      &:first-child {
        border-left: none;
      }

      &.active {
        color: $ucar_main_color;
      }
    }
  }

  .lesson-list-body {
    background-color: $ucar_light_bg;
    flex: 1 0 0;
    position: relative;

    .train-empty {
      padding-top: 280px;
      display: flex;
      flex-flow: column nowrap;
      align-items: center;

      img {
        width: 120px;
        height: 120px;
        margin-bottom: 45px;
      }

      p {
        color: $ucar_font_color;
        font-size: $ucar_font_h4;
        line-height: 1;
      }

      p + p {
        margin-top: 30px;
      }
    }
  }
}
</style>